import React, { useCallback, useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import DialogContentText from "@mui/material/DialogContentText";
import {
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography
} from "@mui/material";
import styled from "styled-components";

type Props = {
    open: boolean
    onClose: () => void
    onSaveClassification: (classification: string[]) => void
    externalObservations?: string[]
}

const ChipContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  margin-top: 8px;
  flex-wrap: wrap;
`

export const UserClassificationsDialog: React.FC<Props> = ({ open, onClose, onSaveClassification, externalObservations }) => {
    const [text, setText] = useState<string[]>(externalObservations || [])
    const [newText, setNewText] = useState("")

    useEffect(() => {
        if (open && externalObservations) {
            setText(externalObservations)
        }
    }, [open, externalObservations])

    const handleKeyPress = useCallback((event: React.KeyboardEvent) => {
        if (event.key === 'Enter' && newText.trim().length > 0) {
            event.preventDefault()
            setText((prevText) => [...prevText, newText.trim()])
            setNewText("")
        }
    }, [newText])

    const handleChipDelete = useCallback((feat: string) => {
        const newFeatures = text.filter(value1 => value1 !== feat);
        setText(newFeatures)
    }, [text])

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}> Minhas Classificações
                <CloseIcon sx={{ cursor: 'pointer', }} onClick={onClose}/>
            </DialogTitle>

            <DialogContent>

                <DialogContentText>
                    Coloque as classificações sobre esse ativo aqui. Essa classificação só será visível pra você e pode ser usada nos mecanismos de busca dentro da plataforma.
                </DialogContentText>

                <TextField
                    fullWidth
                    multiline
                    variant="outlined"
                    helperText={`Aperte Enter para incluir nova observação. Caracteres: ${newText.length}/${25}`}
                    sx={{ marginTop: "16px", width: '100%', minWidth: '200px' }}
                    autoFocus
                    margin="dense"
                    id="outlined-multiline-flexible"
                    label="Classificação"
                    type="text"
                    value={newText}
                    inputProps={{ maxLength: 25 }}
                    onKeyPress={handleKeyPress}
                    onChange={(e) => setNewText(e.target.value)}
                />

                <ChipContainer>
                    { text.map((obs, index) => (
                        <Chip
                            key={index}
                            size="small"
                            variant="filled"
                            onDelete={() => handleChipDelete(obs)}
                            style={{ height: "100%", marginTop: '8px' }}
                            label={<Typography style={{ whiteSpace: "normal" }}>{obs}</Typography>}
                        />
                    ))}
                </ChipContainer>    
            </DialogContent>

            <DialogActions>
                <Button onClick={() => { onSaveClassification(text) }} disabled={text.length === 0}>
                    Salvar
                </Button>
            </DialogActions>

        </Dialog>
    )
}
